export default {
    root: ({ props }) => ({
        class: [
            // Invalid State
            'invalid:focus:ring-feedback-danger_pure',
            'invalid:hover:border-feedback-danger_pure',
            { '!border-feedback-danger_pure': props.invalid },

            // Misc
            'appearance-none',
            'transition-colors duration-200',
        ],
    }),
};
